// http://3.15.93.231/3plapi/user/list

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';

@Injectable()
export class DashboardApiDataService {
   url = environment.url;

   constructor(private http: HttpClient){}

   
    //ATTENTION DATA
    public getAttentionData(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/attention`, payload);
        //return this.http.post("./json/attention.json", payload)
    }

    //TRANSACTION CHART FINE TUNE
    public getTransactionChart(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/transactionsGraph`, payload)
    }

    //DUPLICATE
    public getDuplicateData(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/duplicateCartons`, payload)
    }

    //YTD SCANS
    public getAllScans(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/ytdScanned`, payload)
    }

    //AVERAGE CARTONS SPIRIT
    public getAvgCpp(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/avgCartons`, payload)
    }

    //AVERAGE CARTONS 3PL
    public getAvgCppOrg(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/3plAvgCartons`, payload)
    }

    //UPCOMING BOLs SPIRIT
    public getUpcomingBols(payload: any): Observable<any> {
        //return this.http.post("./json/io-data.json", payload)
        return this.http.post(`${this.url}spirit/upcomingBols`, payload)
    }

    //UPCOMING BOLs SPIRIT
    public getUpcomingBolsV2(payload: any): Observable<any> {
        //return this.http.post("./json/io-data.json", payload)
        return this.http.post(`${this.url}spirit/upcomingBolsV2`, payload)
    }

    //UPCOMING INBOUND 3PLs
    public getUpcomingInbound(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/upcommingInBols`, payload)
    }

    //UPCOMING OUTBOUND 3PLs
    public getUpcomingOutbound(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/upcommingOutBols`, payload)
    }

    //UPCOMING INBOUND 3PLs
    public getUpcomingInboundV2(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/upcommingInBolsV2`, payload)
    }

    //UPCOMING OUTBOUND 3PLs
    public getUpcomingOutboundV2(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/upcommingOutBolsV2`, payload)
    }

    //DOWNLOAD ATTENTION DATA
    public downloadAttentionData(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/downloadAttentionRequired`, payload)
    }

    //DOWNLOAD TRANSACTION DATA
    public downloadTransactionData(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/downloadTransactions`, payload)
    }

    //GET NON MERCH DATA
    public getNonMerchData(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/getCorobuffIseInventoryData`, payload)
    }

    //USER PERFORMANCE METRICS
    public getUserMetrics(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/getUserMetrics`, payload)
    }

    //DOWNLOAD USER PERFORMANCE METRICS
    public downloadUserMetrics(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/downloadUserMetrics`, payload)
    }

    //DOWNLOAD BOL
    public downloadBol(bol: any, lob): Observable<any> {
        return this.http.get(`${this.url}spirit/downloadBolPdf/${bol? `${bol}?` : '?'}lob=${lob}`, {responseType: "arraybuffer"})
    }

    //CARRY OVER CARTONS
    public getCarryOvers(orgId: any, lob: any): Observable<any> {
        return this.http.get(`${this.url}spirit/carryOverCartons/${orgId? `${orgId}?` : '?'}lob=${lob}`);
    }

    //GET KITSHIP DATA
    public getKitShipData(payload: any): Observable<any> {
        return this.http.get(`${this.url}spirit/kitShipData/${payload}`)
    }

    //SAVE KITSHIP DATA
    public saveKitShipData(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/saveKitShipData`, payload)
    }

    //INBOUND CHARTS
    public getInboundCharts(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/transactionsDataGraph`, payload)
    }

    //INBOUND CHARTS
    public getInboundCharts2(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/inboundWidgetBolDataGraph`, payload)
    }

    // TRANSACTION GRIDS
    public transactionsData(payload: any): Observable<any> {
        // return this.http.post(`${this.url}spirit/inboundWidgetBolData`, payload)
        return this.http.post(`${this.url}spirit/transactionsData`, payload)
    }

    //SNAPSHOT
    public getSnapShot(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/attentionDataGraph`, payload)
    }

    //SNAPSHOT DATA
    public getSnapShotData(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/attentionData`, payload)
    }

    //GET SUPPLY DETAILPOST
    public getSupplyDetail(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/supplyTypeDetails`, payload)
    }

    //SUPPLY MARK SHIPPED
    public supplyMarkShipped(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/updateSupplyType`, payload)
    }

    //MASTER SEARCH DATA
    public getMasterSearchData(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/getThreepl`, payload)
    }

    // INBOUND WIDGET BOL DATA
    public inboundWidgetBolData(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/inboundWidgetBolData`, payload)
    }
}